import { hygraphClient } from '@/lib/graphql-clients';
import { getSdk, Page, RowrowComponentsUnion } from '@/lib/types';

import { PressItemProps } from '@/features/press';
import { getPageComponents } from '@/utils/page-static-utils';

export type PressListItemsResponse = {
  [id: string]: PressItemProps[];
};

type GetProps = {
  limit?: number | null;
  featured?: boolean;
  preview?: boolean;
};

const get = async ({
  limit = 0,
  featured = true,
  preview = false,
}: GetProps) => {
  const sdk = getSdk(hygraphClient(preview));
  const { presses } = await sdk.Presses({ limit, filters: { featured } });
  return presses;
};

const getByPage = async (page: Page) => {
  const check = (rc: RowrowComponentsUnion) => rc.__typename === 'PressList';
  const pageComponents = getPageComponents(page, check);

  type PressListComponent = {
    id: string;
    featured?: boolean | null;
    limit?: number | null;
  };

  if (pageComponents.length === 0) {
    return {};
  }

  const pressListRequests = pageComponents.map(
    async (component: PressListComponent) => {
      return PressesService.get({
        featured: component.featured || false,
        limit: component.limit || null,
      });
    }
  );

  const pressListData = await Promise.all(pressListRequests);

  const presses: PressListItemsResponse = {};

  pageComponents.forEach((component, index) => {
    presses[component.id] = pressListData[index];
  });

  return presses;
};

const PressesService = {
  get,
  getByPage,
};

export default PressesService;
